import axios from "axios";
import { useEffect, useState } from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useUserContext } from "../../contexts";

import { useNavigate, Link } from "react-router-dom";

import "../../styles/Navbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

const DropdownMenu = () => {
  const { logout, user, settings, updateSettings } = useUserContext();
  const navigate = useNavigate();

  const locations = user?.locID;
  const [selectedLocation, setSelectedLocation] = useState();

  useEffect(() => {
    if (locations && locations.length > 0 && settings.currentLoc) {
      if (!selectedLocation) {
        let currentLoc = locations.filter(
          (loc) => loc.locationId === settings.currentLoc
        )[0];
        setSelectedLocation(
          currentLoc ? currentLoc.name : "Location not found"
        );
      }
    }
  }, [locations, settings, selectedLocation]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  async function handleLocationChange(id) {
    try {
      await axios.patch("/user/update-current-location", {
        userId: settings.userId,
        locationId: id,
      });
      await updateSettings(); // Refresh settings in context
    } catch (error) {
      console.error("Error updating current location:", error);
    }
  }

  const onLocationSelect = (loc) => {
    setSelectedLocation(loc.name);
    handleLocationChange(loc.locationId);
  };

  return (
    <NavDropdown
      className='m-auto d-flex flex-column text-center'
      title={
        <span>
          {/* <i className='bi bi-person-circle me-2'></i> */}
          My Account
        </span>
      }
      id='dropdownMenuLoc'
    >
      <NavDropdown.Item
        as={Link}
        to={`/profile/${user?.id}`}
        className='text-nowrap'
      >
        <i className='bi bi-person-circle me-2'></i>Profile
      </NavDropdown.Item>
      {locations && locations.length > 1 && (
        <>
          <NavDropdown.Header>
            {locations.length > 1 ? "Change location:" : "Location:"}
          </NavDropdown.Header>

          {locations.map((loc) => (
            <NavDropdown.Item
              key={loc.locationId}
              className='text-nowrap'
              active={loc.name === selectedLocation}
              onClick={(e) => {
                e.preventDefault();
                onLocationSelect(loc);
              }}
            >
              {loc.name}
            </NavDropdown.Item>
          ))}
          <NavDropdown.Divider />
        </>
      )}
      <NavDropdown.Item
        className='logout mx-auto'
        type='button'
        onClick={handleLogout}
      >
        Logout
        <FontAwesomeIcon
          className='dropdown-icon'
          id='logout-icon'
          icon={faArrowRightFromBracket}
        />
      </NavDropdown.Item>
    </NavDropdown>
  );
};

export default DropdownMenu;
